import { render, staticRenderFns } from "./SortTableFiltersDlg.vue?vue&type=template&id=26a50bec&scoped=true"
import script from "./SortTableFiltersDlg.vue?vue&type=script&lang=ts"
export * from "./SortTableFiltersDlg.vue?vue&type=script&lang=ts"
import style0 from "./SortTableFiltersDlg.vue?vue&type=style&index=0&id=26a50bec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a50bec",
  null
  
)

export default component.exports